(function(){
  'use strict';

  angular
    .module('app')
    .directive('inputMaterial', inputMaterial);

  function inputMaterial() {
    return {
      restrict: 'C',
      template: false,
      scope: {},
      transclude: false,
      link: inputMaterialLink
    }
  }

  function inputMaterialLink(scope, element, attrs){
    let inputArea = element[0];

    let bar = document.createElement("div");
    bar.classList.add('input-material__bar');
    inputArea.append(bar);

    let input = inputArea.querySelector('.input-material__input');
    if(input.value) inputArea.classList.add('input-material--has-filled')

    input.addEventListener('keyup', function() {
      if(input.value) inputArea.classList.add('input-material--has-filled')
      else inputArea.classList.remove('input-material--has-filled')
    })
  }

})();
